import clsx from 'clsx'
import { twMerge } from 'tailwind-merge'

import type { IconProps } from './type'

import { ICON_VARIANTS } from './const'

/**
 * アイコンにスタイルを当てるコンポーネント
 * @param size xs=12px, sm=14px, md=16px, lg=18px, xl=20px, 2xl=24px, 3xl=28px, 4xl=32px
 * @param color アイコンの色
 * @returns
 */
export const Icon = ({
  icon,
  size,
  color = 'primary',
  className,
  disabled,
}: IconProps) => {
  const Component = icon
  return Component ? (
    <Component
      aria-disabled={disabled}
      className={twMerge(clsx(ICON_VARIANTS({ size, color })), className)}
    />
  ) : null
}
